import { yupResolver } from "@hookform/resolvers/yup";
import React, { useCallback, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
// import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  postEditCertificateActionHandler,
  postNewCertificateActionHandler,
  uploadCertificateActionHandler,
} from "../../../../store/actions/actionHandlers/adminActionHandler/certificateManagementActionHandler";
import { ManageCertificateSchema } from "../../../../utils/mainTabs/admin/certificateManagement/certificateManagementSchema";
import Button from "../../../Common/Button/Button";
import Input from "../../../Common/Input/Input";
import classes from "./ManageCertificateModalForm.module.scss";
import { FormattedMessage } from "react-intl";
import { setErrorHandler } from "../../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../../utils/errorTypes";
const ManageCertificateModalForm = ({
  certificateData,
  handleManageCertificateModal,
  handleSearchQuery,
}) => {
  const dispatch = useDispatch();
  const [uploadCertificateLoader, setUploadCertificateLoader] = useState(false);
  const [postNewCertificateLoader, setPostNewCertificateLoader] =
    useState(false);
  const [postEditCertificateLoader, setPostEditCertificateLoader] =
    useState(false);
  // const adminStateReducer = useSelector((state) => state.adminReducer);
  // const { certificateManagementReducer } = adminStateReducer;
  // const {
  // uploadCertificateLoader,
  // postNewCertificateLoader,
  // postEditCertificateLoader,
  // } = certificateManagementReducer;
  const [fileUrl, setFileUrl] = useState("");
  const [isCertificateNameExists, setIsCertificateNameExists] = useState(false)
  const [formData, setFormData] = useState({
    CertificateName: "",
    CertificateFile: "",
  });

  useEffect(() => {
    if (certificateData) {
      const formValues = {
        CertificateName: certificateData?.Name,
        CertificateFile: certificateData?.CertificateUrl,
      };
      //   reset(() => formValues);
      setFormData(formValues);
    }
  }, [certificateData]);

  const manageCertificateMethods = useForm({
    resolver: yupResolver(ManageCertificateSchema),
    mode: "onChange",
    defaultValues: formData,
  });

  const {
    handleSubmit,
    reset,
    unregister,
    clearErrors,
    formState: { isValid, errors },
  } = manageCertificateMethods;

  useEffect(() => {
    reset(formData);
  }, [formData, reset]);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const fileName = file.name;
    // const pdfFormat = fileName.split('.').reverse()[0]
    const allowedTypes = ["pdf"];
    if (
      !allowedTypes.includes(
        file?.type.split("/").reverse()[0] || file?.type.split(".").reverse()[0]
      )
    ) {
      unregister("CertificateFile");
      clearErrors();
      dispatch(setErrorHandler(errorTypes.FAIL, "Only PDF file are allowed"));
    } else {
      setUploadCertificateLoader(true);
      dispatch(uploadCertificateActionHandler(fileName, file)).then((data) => {
        setFileUrl(data);
        setUploadCertificateLoader(false);
      });
    }
  };

  const onManageCertificateFormSubmit = (data) => {
    const bodyData = {
      Name: data.CertificateName,
      CertificateUrl: fileUrl,
    };
    if (certificateData) {
      bodyData.Id = certificateData.CertificateID;
      setPostEditCertificateLoader(true);
      dispatch(postEditCertificateActionHandler(bodyData)).then((data) => {
        if (data === 1) {
          handleSearchQuery("");
        }
        setPostEditCertificateLoader(false);
        handleManageCertificateModal(0);
      });
    } else {
      setPostNewCertificateLoader(true);
      dispatch(postNewCertificateActionHandler(bodyData)).then((data) => {
        if (data === 1) {
          dispatch(
            setErrorHandler(
              errorTypes.SUCCESS,
              `Certificate has been created successfully.`
            )
          );
          setPostNewCertificateLoader(false);
          handleSearchQuery("");
          handleManageCertificateModal(0);
        } else {
          setPostNewCertificateLoader(false);
          dispatch(
            setErrorHandler(
              errorTypes.FAIL,
              "Certificate with this name already exists"
            )
          );
        }
      });
    }
  };
  // const handleOnChange = useCallback(
  //   (e) => {
  //     debugger;
  //     const val = e.target.value.trim() !== "" && e.target.value.trim();
  //   if (val) {
  //     if (/^[a-zA-Z0-9:_@?#|'`\]\[ ]*$/.test(val)) {
  //       setIsCertificateNameExists(true);
  //     }
  //     else{
  //       setIsCertificateNameExists(false);
  //     }
  //   } else {
  //     setIsCertificateNameExists(false);
  //   }
  //   },
  //   [setIsCertificateNameExists],
  // )
  // console.log(isCertificateNameExists)
  return (
    <FormProvider {...manageCertificateMethods}>
      <form
        className={classes.manageCertificateModalForm}
        onSubmit={handleSubmit(onManageCertificateFormSubmit)}
      >
        <Input
          name="CertificateName"
          label={<FormattedMessage id="CERTIFICATE_NAME" />}
          labelColor="light"
          placeholder="Enter Name"
          required={true}
          maxlength="40"
          error={errors?.CertificateName?.message}
          // onChange={handleOnChange}
        />
        <Input
          name="CertificateFile"
          label={<FormattedMessage id="Cer_BrowseFile" />}
          labelColor="light"
          placeholder="Choose From Local"
          required={true}
          error={errors?.CertificateFile?.message}
          type="file"
          accept=".pdf"
          hidden
          fileInputButtonWidth="32"
          loading={uploadCertificateLoader}
          onChange={(e) => handleFileUpload(e)}
          handleCancelFileInput={() => setFileUrl("")}
        />
        <div className={classes.manageCertificateModalForm__footer}>
          <Button
            label={<FormattedMessage id="UPLOAD_TEXT" />}
            type="submit"
            // backgroundColor={addTrainingTypeLoader ? undefined : colors.theme}
            // color={addTrainingTypeLoader ? undefined : "#fff"}
            disabled={
              !isValid ||
              uploadCertificateLoader ||
              (!certificateData && !fileUrl)
            }
            loading={postNewCertificateLoader || postEditCertificateLoader}
            borderRadius="0.7"
            width="14.5"
            height="4.9"
            dark
          />
        </div>
      </form>
    </FormProvider>
  );
};

export default ManageCertificateModalForm;
